export default __webpack_public_path__ + "static/media/1_the_hotels_network.30575728.svg";